import { render, staticRenderFns } from "./RoleAcceptance.html?vue&type=template&id=0c70b1c9&scoped=true&"
import script from "./RoleAcceptance.js?vue&type=script&lang=js&"
export * from "./RoleAcceptance.js?vue&type=script&lang=js&"
import style0 from "./RoleAcceptance.scss?vue&type=style&index=0&id=0c70b1c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c70b1c9",
  null
  
)

export default component.exports